<template>
  <b-nav-item-dropdown ref="notification-dropdown" class="dropdown-notification mr-25" menu-class="dropdown-menu-media" right @show="onShow">
    <template #button-content>
      <feather-icon v-if="unreadMessagesCount > 0" v-bind:badge="unreadMessagesCount" badge-classes="bg-danger" class="text-body" icon="MessageSquareIcon" size="21"/>
      <feather-icon v-else badge-classes="bg-danger" class="text-body" icon="MessageSquareIcon" size="21"/>
    </template>

  </b-nav-item-dropdown>
</template>

<script>


import { mapActions } from 'vuex'

export default {
  name:"ChatToggler",
  data:()=>({
    unreadMessagesCount:0,
    checkUnreadMessagesInterval:null,
    checkUnreadMessagesTimeout:null,
  }),
  created() {
    this.checkUnreadMessages();
    this.checkUnreadMessagesInterval = setInterval(()=>{
      this.checkUnreadMessages();
    },30*1000);
    this.$root.$on('system::notification::CHAT', this.onChatNotification);
    this.$root.$on('system::chat::unread::changed', this.checkUnreadMessagesSoon);
  },
  beforeDestroy() {
    clearInterval(this.checkUnreadMessagesInterval);
    clearTimeout(this.checkUnreadMessagesTimeout);
    this.$root.$off('system::notification::CHAT', this.onChatNotification);
    this.$root.$off('system::chat::unread::changed', this.checkUnreadMessagesSoon);
  },
  computed:{

  },
  methods: {
    ...mapActions('chat', ['fetchUnreadMessagesCount','getChatMessages']),
    onShow(event) {
      // No dropdown content — the icon just navigates to the chat page
      if (event && typeof event.preventDefault === 'function') event.preventDefault();
      this.$emit('show');
      this.checkUnreadMessages();
      if (this.$route?.name !== 'clientsChat') {
        this.$router.push({ name: 'clientsChat' }).catch(() => {});
      }
    },
    onChatNotification(payload) {
      if (payload?.params?.type === 'chatMessage') {
        this.checkUnreadMessagesSoon();
      }
    },
    // Debounced so a burst of messages / read receipts triggers a single request
    checkUnreadMessagesSoon() {
      clearTimeout(this.checkUnreadMessagesTimeout);
      this.checkUnreadMessagesTimeout = setTimeout(() => this.checkUnreadMessages(), 1000);
    },
    checkUnreadMessages() {
      this.fetchUnreadMessagesCount().then(count=>{
        this.unreadMessagesCount = count?.total || 0;
      }).catch(() => {});
    }
  }
}
</script>

<style>

</style>
